export default __webpack_public_path__ + "static/media/stage_01@2x.7ce700bf.png";